<template>
  <div class="main" v-loading="loading">
    <el-page-header icon="ArrowLeft" v-if="foldForm.id" @back="goBack">
      <template #content>
        <span class="page_header_name"> {{ foldForm.name }} </span>
      </template>
    </el-page-header>
    <div v-if="foldForm.id">
      <el-upload :http-request="customUpload" :key="foldForm.id" drag :before-upload="beforeUpload">
        <el-icon class="el-icon--upload"><upload-filled /></el-icon>
        <div class="el-upload__text">
          拖拽文件到此处或<em>点击上传</em>
        </div>
      </el-upload>
      <div style="width: 96%; margin: 0 auto; margin-top: 10px" v-if="foldForm.item?.length > 0">
        <div v-for="(item1, index) in foldForm.item" class="list_div" :key="index">
          <div class="list_list">
            <div class="list_left" @click="check(item1)">
              <div style="display: flex; align-items: center; width: 100%">
                <i class="iconfont icon-wenjianleixing-biaozhuntu-gongzuobiao"
                  v-if="item1.fileType == 'xlsx' || item1.fileType == 'xls'"></i>
                <i class="iconfont icon-wenjianleixing-biaozhuntu-jishiben" v-else-if="item1.fileType == 'txt'"></i>
                <i class="iconfont icon-wenjianleixing-biaozhuntu-huandengpian" v-else-if="item1.fileType == 'ppt'"></i>
                <i class="iconfont icon-wenjianleixing-biaozhuntu-yasuowenjian" v-else-if="item1.fileType == 'zip'"></i>
                <i class="iconfont icon-wenjianleixing-biaozhuntu-PDFwendang" v-else-if="item1.fileType == 'pdf'"></i>
                <i class="iconfont icon-wenjianleixing-biaozhuntu-Wordwendang" v-else-if="
                  item1.fileType == 'docx' || item1.fileType == 'doc'
                "></i>
                <i class="iconfont icon-wenjianleixing-biaozhuntu-weizhiwenjian" v-else></i>
                <div style="
                      display: flex;
                      flex-direction: column;
                      margin-left: 15px;
                      width: 80%;
                    ">
                  <p class="wj_title" style="font-size: 12px">
                    {{ item1.name }}
                  </p>
                  <div style="color: #afaeae; font-size: 12px; margin-top: 5px">
                    <p>{{ item1.createTime }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <el-icon color="red" style="font-size: 14px" @click="delFile(item1, 1)">
                <delete />
              </el-icon>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 20px" v-else>
        <el-empty description="暂无文件"></el-empty>
      </div>
    </div>
    <div v-else>

      <div class="input_class">
        <div>
          <el-button size="small" type="success" icon="Plus" @click="addFile" plain>新建文件夹</el-button>
        </div>
      </div>
      <div style="margin-top: 20px" v-if="fileList.length != 0">
        <div class="list_div" v-for="(item, index) in fileList" :key="index">
          <div class="list_list">
            <div class="list_left" @click="checkFold(item)">
              <div style="display: flex; align-items: center; width: 100%">
                <i class="iconfont icon-weibiaoti-_huabanfuben"></i>
                <div style="
                  display: flex;
                  flex-direction: column;
                  margin-left: 15px;
                  width: 80%;
                ">
                  <p class="wj_title">{{ item.name }}</p>
                  <div style="
                    display: flex;
                    align-items: center;
                    color: #afaeae;
                    font-size: 12px;
                    margin-top: 5px;
                  ">
                    <p v-if="item.item != null">
                      {{ item.item.length ? item.item.length : 0 }}项
                    </p>
                    <p v-else>0项</p>
                    <p style="margin-left: 25px">{{ item.createTime }}</p>
                  </div>
                </div>
              </div>
            </div>
            <el-popover placement="left" trigger="click" width="70" ref="popover" popper-class="classpopper">
              <template #reference>
                <i class="iconfont icon-gengduo-shuxiang"></i>
              </template>
              <!-- <p class="open_text" @click="uploadFile(item)">上传</p> -->
              <p class="open_text" style="margin-top: 5px" @click="delFile(item, 2)">
                删除
              </p>
            </el-popover>
          </div>


        </div>
      </div>
      <div style="margin-top: 20px" v-else>
        <el-empty description="暂无文件"></el-empty>
      </div>
    </div>
  </div>
  <!-- 新建文件夹start -->
  <el-dialog title="新建文件夹" v-model="dialogVisible" width="80%">
    <el-form size="small">
      <el-form-item label="文件夹名称">
        <el-input v-model="fileName" placeholder="请输入"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="addSure" size="small">确 定</el-button>
      </span>
    </template>
  </el-dialog>
  <!-- 新建文件夹end -->
  <!-- 上传文件start -->
  <el-dialog title="文件上传" v-model="dialogUploadVisible" width="80%">
    <el-input style="width: 60%; margin-right: 10px" v-model="path" size="small"></el-input>
    <input size="small" ref="inputRef" class="excel-upload-input" style="display: none" type="file"
      @change="handleClick" />
    <el-button type="primary" @click="handleUpload()" size="small">请选择文件</el-button>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogUploadVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="uploadExcel" size="small">确 定</el-button>
      </span>
    </template>
  </el-dialog>
  <!-- 上传文件end -->
</template>
<script setup>
import { ref, getCurrentInstance, watch } from "vue";
import { getFFList, delFF, createFolder, upload } from "@/api/file";
import { ElMessage } from "element-plus";
const props = defineProps({
  period: { type: String, default: "" },
  comInfo: { type: Object, default: () => { } },
})
const { proxy } = getCurrentInstance();
const inputRef = ref(null);
const comId = ref(null);
const fileName = ref("");
const fileList = ref([]);
const dialogVisible = ref(false);
const dialogUploadVisible = ref(false);
const rawFile = ref("");
const path = ref("");
const folderId = ref(null);
const loading = ref(false);
const comForm = ref({})
const foldForm = ref({})
const getList = () => {
  loading.value = true;
  getFFList({
    taxNo: comForm.value.taxNo,
  }).then((res) => {
    loading.value = false
    if (res.data.msg == "success") {
      fileList.value = res.data.data || [];
      if (foldForm.value?.id) {
        foldForm.value = fileList.value.find(item => item.id == foldForm.value.id)
      }
    }
  });
};
//新建文件夹
const addFile = () => {
  dialogVisible.value = true;
  fileName.value = "";
};
const addSure = () => {
  createFolder({
    taxNo: comForm.value.taxNo,
    name: fileName.value,
  }).then((res) => {
    if (res.data.msg == "success") {
      ElMessage.success("新增成功");
      getList();
      dialogVisible.value = false;
    }
  });
};
///上传文件
const uploadFile = (item) => {
  dialogUploadVisible.value = true;
  folderId.value = item.id;
};
const handleUpload = () => {
  inputRef.value.click();
};
const handleClick = (e) => {
  let files = e.target.files;
  rawFile.value = files[0]; // only use files[0]
  path.value = e.target.value; //路径
};
const uploadExcel = () => {
  if (rawFile.value == "") {
    ElMessage.warning("请选择文件");
    return;
  }
  const param = new FormData();
  param.append("file", rawFile.value, rawFile.value.name);
  param.append("taxNo", comForm.value.taxNo);
  param.append("folderId", folderId.value);
  upload(param).then((res) => {
    if (res.data.msg == "success") {
      ElMessage.success("上传成功");
      dialogUploadVisible.value = false;
      getList();
    }
  });
};
//查看文件
const check = (item) => {
  window.open(item.filePath);
};
//删除文件
const delFile = (item, type) => {
  proxy
    .$confirm("确认删除该文件？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
    .then(() => {
      delFF({
        id: item.id,
        fileType: type,
      }).then((res) => {
        if (res.data.msg == "success") {
          ElMessage.success("成功删除");
          getList();
        }
      });
    })
};
watch(
  () => [props.period, props.comInfo],
  (newVal) => {
    comId.value = newVal[1].id
    comForm.value = newVal[1]
    if (comId.value) {
      getList()
    }
  },
  { immediate: true }
)
//上传文件
const customUpload = (options) => {
  const { file } = options;
  const formData = new FormData();
  let title = file.name.replace(/,/g, ""); // 清理文件名中的逗号
  formData.append("file", file, title);
  formData.append("taxNo", comForm.value.taxNo); // 税号
  formData.append("folderId", foldForm.value.id
  ); // 使用 currentItem.id 作为 folderId
  upload(formData)
    .then((res) => {
      if (res.data.msg === "success") {
        ElMessage.success("上传成功");
        getList(); // 刷新文件列表
      }
    })
    .catch(() => {
      ElMessage.error("上传失败");
    });
};
const beforeUpload = (file) => {
  const isLt10M = file.size / 1024 / 1024 < 10;
  if (!isLt10M) {
    ElMessage.error("文件大小不能超过10MB");
  }
  return isLt10M;
};
const checkFold = (item) => {
  foldForm.value = Object.assign(item, {})
}
const goBack = () => {
  foldForm.value = {}
}
</script>
<style scoped lang="scss">
.main {
  background-color: #fff;
  padding: 10px 0;
}

.input_class {
  width: 90%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.fdj {
  font-size: 20px;
  margin-right: 10px;
}

.title {
  color: #d6d5d5;
  margin-left: 20px;
  font-size: 12px;
  margin-top: 10px;
}

.btn_div {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;

  .btn {
    width: 45%;
    text-align: center;
  }
}

.sc {
  font-size: 16px;
}

.click_sc {
  color: #fff;
  font-size: 13px;
  margin-left: 5px;
}

.list_list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 7px;
}

.wj_title {
  font-size: 13px;
  width: 70%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.upload-demo {
  width: 80%;
  margin-top: 20px;
}

.open_text {
  font-size: 10px;
  text-align: center;
  cursor: pointer;
}

.file_title {
  display: flex;
  align-items: center;
}

.list_left {
  width: 90%;
}

.iconfont {
  font-size: 20px;
  margin-left: 10px;
}

:deep(.el-upload-list) {
  display: none;
}

:deep(.el-page-header__header) {
  padding-left: 10px;
}

.page_header_name {
  font-size: 14px;
}

:deep(.el-upload-dragger) {
  padding: 10px;
}
</style>
